import { useState } from 'react'
import { Box, Button, Grid, MenuItem, Paper, TextField, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { createDevice } from '../../api/device'
import { Device } from '../../types/api'

export default function GpsDeviceCreatePage() {
  const navigate = useNavigate()
  const [form, setForm] = useState<Partial<Device>>({
    boxId: '',
    simNumber: '',
    firmware: '',
    sr: '',
    simLot: '',
  })

  const handleChange = (field: keyof Device, value: any) => {
    setForm((prev) => ({ ...prev, [field]: value }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await createDevice(form)
    navigate('/devices')
  }


  return (
    <Box>
      <Typography variant="h6" mb={2}>เพิ่มอุปกรณ์ GPS</Typography>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            
            <Grid size={6}>
              <TextField
                fullWidth
                label="Box ID"
                value={form.boxId || ''}
                onChange={(e) => handleChange('boxId', e.target.value)}
                required
              />
            </Grid>

            <Grid size={6}>
              <TextField
                fullWidth
                label="SIM Number"
                value={form.simNumber || ''}
                onChange={(e) => handleChange('simNumber', e.target.value)}
              />
            </Grid>

            <Grid size={6}>
              <TextField
                fullWidth
                label="Firmware"
                value={form.firmware || ''}
                onChange={(e) => handleChange('firmware', e.target.value)}
              />
            </Grid>

            <Grid size={6}>
              <TextField
                fullWidth
                label="SR"
                value={form.sr || ''}
                onChange={(e) => handleChange('sr', e.target.value)}
              />
            </Grid>

            <Grid size={6}>
              <TextField
                fullWidth
                label="SIM Lot"
                value={form.simLot || ''}
                onChange={(e) => handleChange('simLot', e.target.value)}
              />
            </Grid>

            <Grid size={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: '#FEDC00', color: '#000' }}
              >
                บันทึก
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  )
}